module.exports = __webpack_public_path__ + "hyperion-v2-static/img/welcome_to_core_plus_hyperion.1b214ced.png";